var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loading',{attrs:{"msg":"正在登录..."}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }